import { useCallback, useEffect, useState } from "react";
import { NEXT_PUBLIC_API_BASE_URL } from "app/client";

export type InviteType = "INTERNAL_ORGANIZATION" | "ORGANIZATION" | "USER";

export interface Invite {
  id: string;
  expireTime: string;
  type: InviteType;
  organizationId: string;
  organizationName: string;
  avatarUrl: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  userIdList: string[];
}

interface IProps {
  inviteId: string;
}

export const API_INVITE_PATH = "/invite";

const useInvite = ({ inviteId }: IProps) => {
  const [invite, setInvite] = useState<Invite>();

  const fetchInvite = useCallback(
    () =>
      fetch(`${NEXT_PUBLIC_API_BASE_URL}${API_INVITE_PATH}/${inviteId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    [inviteId],
  );

  useEffect(() => {
    fetchInvite()
      .then((response) => response.json())
      .then(setInvite);
  }, [fetchInvite]);

  return {
    invite,
  };
};

export default useInvite;
